import { expressCheckoutWidgetButtonClicked } from '@wix/bi-logger-cashier-ugc/v2';
import { amountToLong } from '../../../../utils/amountToLong';
import { onClickHandler } from '../../../../services/utils/onClickHandler';
import { WidgetProps } from '../../../../types/WidgetProps';
import { BiLogger } from '../../../Hoc/BiLogger/BiLoggerProvider';
import { BiOriginProduct, BiPmGooglePay, BiPpWp } from '../../../Hoc/BiLogger/constants';

type CreateOnShippingContactSelectedParams = {
  topProps: WidgetProps;
  biLogger: BiLogger;
};

export const createOnClick =
  ({ topProps, biLogger }: CreateOnShippingContactSelectedParams) =>
  async (e: Event) => {
    const { paymentAmount, currency, meta } = topProps;
    biLogger.report(
      expressCheckoutWidgetButtonClicked({
        amountLong: amountToLong(paymentAmount),
        appInstanceId: meta.appInstanceId,
        currency,
        paymentProvider: BiPpWp,
        paymentmethod: BiPmGooglePay,
        productId: meta.productId,
        origin: BiOriginProduct,
      }),
    );

    // Validate possibility to pay by vertical
    const { canceled } = await onClickHandler({
      onClick: topProps.onClick,
      logErrorParams: {
        message: '[GooglePay] props.onClick() throws exception',
        fingerprint: ['googlePay', 'onClick'],
      },
    })();

    if (canceled) {
      // Prevent display of the payment sheet
      e.preventDefault();
    }
  };
